import * as React from "react";
import { cn } from "helpers/utils";

const badgeVariants = {
  variant: {
    default:
      "border-transparent bg-primary-900 text-white hover:bg-primary-800",
    secondary:
      "border-transparent bg-primary-100 text-dark-teal hover:bg-primary-200",
    destructive: "border-transparent bg-system-red text-white hover:bg-red-600",
    outline: "text-gray-900",
  },
} as const;

type BadgeVariant = keyof typeof badgeVariants.variant;

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: BadgeVariant;
}

function Badge({ className, variant = "default", ...props }: BadgeProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-primary-900 focus:ring-offset-2",
        badgeVariants.variant[variant],
        className
      )}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
export type { BadgeProps, BadgeVariant };
